<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="lopperTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="garbageImg" slot-scope="data">
          <img class="table-img" v-if="data.row.garbageImg && data.row.garbageImg.length > 0" :src="imgUrl + data.row.garbageImg.split(',')[0]">
        </template>
        <template slot="garbageWeight" slot-scope="data">
          <span>{{ $wtUtil.transWeight(data.row.garbageWeight) }}</span>
        </template>
        <template slot="deliveryWay" slot-scope="data">
          <span>{{data.row.deliveryWay | FILTER_Delivery_State}}</span>
        </template>
       </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_USERDELIVERYGARBAGE',
        formComponent: {
          view: { type: 'component', componentName: 'DeliveryGeneralEdit', value: '', noRequest: true },
          edit: { type: 'component', componentName: 'DeliveryGeneralEdit', value: '', noRequest: true },
          list: { type: 'default', value: '/modules/userDeliveryGarbage/userDeliveryGarbageList' }
        },
        formInputsData: [{ name: '搜索用户', key: 'nickName', value: '', type: 'text' },
          { name: '投递时间', key: 'dataTimeRange', value: [], type: 'datetime' },
          { name: '用户类型', key: 'userType', value: 1, type: 'customAllFixed', display: 'more' },
          { name: '投递方式',
            key: 'deliveryWay',
            value: '',
            type: 'select',
            data: [{ label: '全部', value: '' },
              { label: '线下', value: 1 },
              { label: '投递柜', value: 2 },
              { label: '代投', value: 3 },
              { label: '扫描固定二维码', value: 4 }] },
          { name: '投递柜订单', key: 'onlineOrderId', value: '', type: 'text' },
          { name: '投递柜', key: 'onlineMachine', value: '', type: 'text' },
          { name: '社区', key: 'communityId', value: '', type: 'select', data: [], filterable: true },
          { name: '站点',
            key: 'siteId',
            value: '',
            type: 'cascader',
            options: [],
            filterable: true,
            props: {
              children: 'childList', label: 'name', value: 'id', expandTrigger: 'hover', emitPath: false }}],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userDeliveryGarbage/userDeliveryGarbageListImport',
          fileName: '普通用户垃圾投递',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '用户昵称', key: 'nickName', type: 'text' },
          { name: '投递柜订单编号', key: 'onlineOrderId', type: 'text', minWidth: 110 },
          { name: '投递物品', key: 'garbageName', type: 'text' },
          { name: '投递总量(kg)', key: 'garbageWeight', type: 'custom', minWidth: 110 },
          { name: '单价(个)', key: 'garbagePrice', type: 'text' },
          { name: '总积分(个)', key: 'garbageTotalPrice', type: 'text', minWidth: 100 },
          { name: '投递方式', key: 'deliveryWay', type: 'custom' },
          { name: '投递柜', key: 'onlineMachine', type: 'text' },
          { name: '投递时间', key: 'createTime', type: 'text', sortable: 'custom', minWidth: 100 },
          { name: '操作人员', key: 'employeesUserName', type: 'text' },
          { name: '站点', key: 'siteName', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '货物图片', key: 'garbageImg', type: 'custom' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
          { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonWidth: 130 }
      }
    }
  },
  created() {
    this.orgTreeList()
    this.$store.dispatch('queryCommunityNoPageList').then(res => {
      this.form.formInputsData[6].data = res
    })
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
          const params = JSON.parse(JSON.stringify(data.row))
          params.garbageWeight = this.$wtUtil.transWeight(params.garbageWeight)
          params.garbageTypeId = data.row.garbageTypeId * 1
          this.$store.dispatch('setUserDeliveryGarbageDetailData', params)
        }
      }
    },
    // 站点
    orgTreeList() {
      this.$api.siteManage.org.orgTreeList().then(res => {
        this.$wtUtil.setSiteLevelKey(res.data)
        this.form.formInputsData[this.form.formInputsData.length - 1].options = res.data
      })
    }
  }
}
</script>
